// extracted by mini-css-extract-plugin
export default {"previewSection":"ReactCropper_previewSection__8qvOV","cropperSection":"ReactCropper_cropperSection__vw0G5"};